import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TabNavBarComponent } from './tab-nav-bar.component';

@NgModule({
  imports: [CommonModule, MatTabsModule, RouterModule, TranslatePipe],
  declarations: [TabNavBarComponent],
  exports: [TabNavBarComponent]
})
export class TabNavBarModule {}
